import { watch } from 'vue'

export const useMobileWidths = ({ gridApi, gridOptions }) => {
  const updateColumnWidths = () => {
    const isMobile = window.innerWidth <= 1280 // 1280px is the breakpoint for xl
    gridOptions.value.columnDefs.forEach((colDef) => {
      if (isMobile) {
        gridApi.value.setColumnWidths([{ key: colDef.field, newWidth: colDef.mobileWidth ?? colDef.width }])
      } else {
        if (!colDef.flex) {
          gridApi.value.setColumnWidths([{ key: colDef.field, newWidth: colDef.desktopWidth ?? colDef.width }])
        }
      }
    })
  }

  watch(
    gridApi,
    () => {
      updateColumnWidths()
    },
    { once: true }
  )
}
